// The homepage gallery.
//
// Both variants come out of the same capture run of the real program, so the
// gallery follows the reader's theme. They share the folders the documentation
// screenshots use — /images/docs/light and /images/docs/dark — because they are
// the same pictures and a second copy is a copy that goes stale.
//
// Regenerate with tools/import-screenshots.sh after a capture run.

const shot = (name) => ({
  image: `/images/docs/light/${name}.png`,
  darkImage: `/images/docs/dark/${name}.png`,
});

export const screenshots = [
  {
    id: 'picker',
    title: 'Every world, in one place',
    description: 'Found automatically across every Minecraft install on the machine, grouped by which one put them there, with sizes and a health check on each.',
    ...shot('picker'),
  },
  {
    id: 'world-map',
    title: 'World Map',
    description: 'Your whole world drawn from its own blocks, in all three dimensions. Slice it at any height to see inside a base, or right-click a chunk to inspect it.',
    ...shot('world-world.map-overview'),
  },
  {
    id: 'pruning',
    title: 'Chunk Pruning',
    description: 'Draw the areas you want to keep, invert to prune inside them instead, and see how many chunks go before anything is staged.',
    ...shot('world-world.map'),
  },
  {
    id: 'inventory',
    title: 'Player Inventory',
    description: 'Hotbar, armour, offhand and ender chest, laid out as Minecraft lays them out. Drag items between slots, or open one and give it enchantments the game would never allow.',
    ...shot('player-player.inventory'),
  },
  {
    id: 'villages',
    title: 'Villages',
    description: 'Who lives in each village, what they have claimed, and which claims are held by villagers that no longer exist — which is usually why the village stopped breeding.',
    ...shot('world-world.villages'),
  },
  {
    id: 'entities',
    title: 'Entities',
    description: 'Every mob and object in the world, grouped by type, with its raw data editable and a jump straight to it on the map.',
    ...shot('world-world.entities'),
  },
  {
    id: 'trades',
    title: 'Villager Trades',
    description: 'Edit what any villager buys and sells, tier by tier — items, quantities, enchantments, armour trims and how many times a trade can be taken.',
    ...shot('world-world.trades-editor'),
  },
  {
    id: 'structures',
    title: 'Structures',
    description: 'Everything saved with a structure block, rendered in 3D with the block list it would take to build again. Export to .mcstructure, or import one in.',
    ...shot('world-world.structures'),
  },
  {
    id: 'addons',
    title: 'Add-ons',
    description: 'The packs in your world and the packs on your computer. Reorder them, update them, see which are missing files or unmet dependencies, and patch packs to keep achievements working.',
    ...shot('addons-addons.world'),
  },
  {
    id: 'scoreboards',
    title: 'Properties & Scoreboards',
    description: 'The scoreboard behind /scoreboard — objectives, display slots and every score — plus the custom data your add-ons keep on the world itself.',
    ...shot('world-world.properties-scoreboards'),
  },
  {
    id: 'gamerules',
    title: 'Game Rules',
    description: 'All 31 rules as switches, grouped by what they affect, each with a plain explanation of what it actually does.',
    ...shot('level-level.gamerules'),
  },
  {
    id: 'block-search',
    title: 'Block Search',
    description: 'Name a block and get every coordinate it stands at, anywhere in the world. Narrow it to a range, jump to any result on the map, or export the lot as a spreadsheet.',
    ...shot('world-world.block_search'),
  },
  {
    id: 'backups',
    title: 'Backups',
    description: 'Kept outside the world folder, so they survive the world being deleted. Restore, verify, lock, or recreate a world that is no longer there.',
    ...shot('backups'),
  },
  {
    id: 'console',
    title: 'Console',
    description: 'Everything the program has done this session, written to disk as it goes — so the log from a session that crashed is still there afterwards.',
    ...shot('console'),
  },
];
